var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_4272_3514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.88896 0.414844L3.72021 0.75H1.47021C1.05537 0.75 0.720215 1.08516 0.720215 1.5C0.720215 1.91484 1.05537 2.25 1.47021 2.25H10.4702C10.8851 2.25 11.2202 1.91484 11.2202 1.5C11.2202 1.08516 10.8851 0.75 10.4702 0.75H8.22021L8.05146 0.414844C7.9249 0.159375 7.66475 0 7.38115 0H4.55928C4.27568 0 4.01553 0.159375 3.88896 0.414844ZM10.4702 3H1.47021L1.96709 10.9453C2.00459 11.5383 2.49678 12 3.08975 12H8.85068C9.44365 12 9.93584 11.5383 9.97334 10.9453L10.4702 3Z",
    fill: "#081D42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4272_3514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/Remove.e821727edf47c2d88b3e7d9ee142655b.svg";
export { ForwardRef as ReactComponent };